import React from 'react';
import PropTypes from 'prop-types';
import { startCase } from 'lodash';

import TextCell from 'app/components/data-table/TextCell';

export default function StatusReasonCell({ statusReason }) {
  try {
    const formattedStatusReason = formatStatusReason(statusReason);
    return <TextCell text={formattedStatusReason} />;
  } catch (error) {
    console.error('Failed to format status reason', error);

    return <TextCell text={statusReason} />;
  }
}

StatusReasonCell.propTypes = {
  statusReason: PropTypes.string.isRequired,
};

function formatStatusReason(statusReason) {
  const formattedStatusReason = startCase(statusReason.toLowerCase().replace(/_/g, ' ').trim());

  return formattedStatusReason;
}
